// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__PBiOy","main":"siteloader_main__K1ckv","center":"siteloader_center__rQhcV","middle":"siteloader_middle__uU06I","top":"siteloader_top__n-7xx"};